import "./Header.scss";
import PrincipalDialog from "@/components/Common/PrincipalDialog/PrincipalDialog.vue";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import EoHeimatIcon from "../../../customIcons/EoHeimatIcon.vue";
import { changeItemSelection } from "../../../helpers/commonHelper";

export default {
  name: "Header",
  data: () => ({}),
  components: {
    EoHeimatIcon,
    PrincipalDialog
  },
  async mounted() {
    await this.$store.dispatch("getCurrentUser");
    if (!this.modules) await this.$store.dispatch("getNavbarItems");
  },
  methods: {
    changeItemSelection,
    async logout() {
      localStorage.removeItem("authRefreshToken");
      localStorage.removeItem("session");
      localStorage.removeItem("impersonatedBy");
      localStorage.removeItem("selectedPrincipal");
      this.$store.state.session = null;
      this.$store.state.currentUser = null;
      this.$store.state.modules = null;
      window.location.href = "/login";
    },
    async endImpersonation() {
      const isConfirmed = await this.$confirm(
        "Zum Admin-Account zurückkehren?",
        confirmWarningConfig
      );
      if (isConfirmed) {
        localStorage.session = localStorage.impersonatedBy;
        localStorage.removeItem("impersonatedBy");
        window.location = "/";
      }
    }
  },
  computed: {
    modules() {
      return this.$store.state.modules;
    },
    moduleName() {
      return this.$store.state.module.name;
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes?.includes("role:admin");
    },
    user() {
      return this.$store.state.currentUser;
    },
    impersonated() {
      return localStorage.getItem("impersonatedBy")?.length || false;
    }
  },
  props: ["mobileMenuOpen"]
};
